export default "__VITE_ASSET__Cjr8eUFi__"